import { SimpleDocCommand } from '../../apps/DocsApp/commands/v5/types';
import { StandardToolResult } from '../../types/standardToolResults';
import { CommandExecutionContext } from '../../types/commands';
import { getApplicationForEntity } from '../../services/applicationRegistry';

export const entity_add_comment: SimpleDocCommand = {
  id: 'entity_add_comment',
  logicalName: 'entity_add_comment',
  version: 'v2',

  description: 'Add a comment to an entity.',

  schema: {
    parameters: [
      { name: 'entityId', type: 'string', description: 'Entity ID.', required: true },
      { name: 'nodeId', type: 'string', description: 'Node ID to comment on (get from entity_read).', required: true },
      { name: 'comment', type: 'string', description: 'Comment text.', required: true },
      { name: 'metadata', type: 'object', description: 'Optional metadata. Example: { priority: "high", category: "review" }.', required: false }
    ]
  },

  handler: async (params: any, context: CommandExecutionContext): Promise<StandardToolResult> => {
    const { entityId, nodeId, comment, metadata } = params;
    const app = await getApplicationForEntity(entityId);
    if (!app) return { status: 'error', message: 'Entity not found or not a v2 entity', format: 'plaintext' };
    const result = await app.handleEntityAddComment(nodeId, comment, metadata);
    return { status: 'success', message: 'Comment added to node', data: { entityId, nodeId, commentId: result.commentId, comment }, format: 'json' };
  }
};
